import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { APP_PRIMARY } from 'colours';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

export default function CustomDialog(props) {
  const useDialogStyles = makeStyles({
    root: { fontSize: '20px' },
    paper: {
      background: props.backgroundColor,
      borderRadius: props.noBorder ? '0px' : '14px',
    },
    closeButton: {
      position: 'absolute',
      right: '5px',
      top: '5px',
      color: APP_PRIMARY,
    },
    title: {
      padding: 0,
    },
    closeIcon: {
      width: '40px',
      height: '40px',
    },
  });

  const classes = useDialogStyles();
  return (
    <Dialog {...props} classes={classes}>
      <MuiDialogTitle className={classes.title}>
        {props.onCloseButton && (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={props.onCloseButton}
          >
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        )}
      </MuiDialogTitle>
      <MuiDialogContent>{props.children}</MuiDialogContent>
    </Dialog>
  );
}

CustomDialog.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
};
